import { AJOUTE_DATA_RESTAURANT, SUPRIMER_DATA_RESTAURANT } from '../types/typeDataRestaurant';

const data = [];

const DataRestaurantReducer = (state = data, action) => {
  switch (action.type) {
    case AJOUTE_DATA_RESTAURANT:
      state = action.payload;
      return state;
    case SUPRIMER_DATA_RESTAURANT:
      return state = [];
    default:
      return state;
  }
}

export default DataRestaurantReducer;
